import { createAction, props } from '@ngrx/store';
import { AnaBizApplicationListState } from './ana-biz-application-list.state';

/** StateDetailsActions */
const ACTION_SET = '[AnaBizApplicationList] set';
const ACTION_UPDATE = '[AnaBizApplicationList] update';
const ACTION_RESET = '[AnaBizApplicationList] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setAnaBizApplicationList = createAction(ACTION_SET, props<AnaBizApplicationListState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateAnaBizApplicationList = createAction(ACTION_UPDATE, props<Partial<AnaBizApplicationListState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetAnaBizApplicationList = createAction(ACTION_RESET);
